export const isDescendant = (target: HTMLElement | null, parentElements: HTMLElement[]): boolean =>{
    if (!target) return false;
    let currentElement: HTMLElement | null = target;
    while (currentElement !== null && currentElement !== document.body) {
        if (parentElements.includes(currentElement)) {
            return true;
        }
        currentElement = currentElement.parentElement;
    }
    return false;
}

export const isFocusable = (element) => {
    return element.tabIndex >= 0 && !element?.disabled &&
        getComputedStyle(element)?.visibility !== 'hidden' &&
        getComputedStyle(element)?.display !== 'none';
};